import {
  AbstractControl,
  FormArray,
  FormControl,
  FormGroup,
  UntypedFormBuilder,
  ValidationErrors,
} from '@angular/forms';

export function scrollToTop() {
  if (typeof window === 'undefined') {
    return; // no-op during SSR
  }
  window.scrollTo({
    top: 0,
    left: 0,
    behavior: 'smooth',
  });
}

export function customPasswordMatching(
  control: AbstractControl
): ValidationErrors | null {
  const password = control.get('newPassword')?.value;
  const confirmPassword = control.get('confirmPassword')?.value;

  return password === confirmPassword ? null : { passwordMismatchError: true };
}

interface IClearNullCriteria {
  skipArray: boolean;
  skipString: boolean;
  clearFalse: boolean;
}

export const clearNullValues = (
  values: any,
  criteria: Partial<IClearNullCriteria> = {}
) => {
  for (const key in values) {
    if (values.hasOwnProperty(key)) {
      try {
        if (values[key] === null || values[key] === undefined) {
          delete values[key];
        }

        /**
         * should be ignored when values.tpe is BOOLEAN and key is defaultValue
         */
        if (
          criteria.clearFalse &&
          values[key] === false &&
          !(key === 'defaultValue' && values.tpe === 'BOOLEAN')
        ) {
          delete values[key];
        }
        if (
          !criteria.skipArray &&
          Array.isArray(values[key]) &&
          values[key].length === 0
        ) {
          delete values[key];
        }
        if (
          !criteria.skipString &&
          typeof values[key] === 'string' &&
          values[key].length === 0
        ) {
          delete values[key];
        }
      } catch (error) {
        // ignore malformed values
      }
      if (typeof values[key] === 'object') {
        clearNullValues(values[key], criteria);
      }
      if (
        typeof values[key] === 'object' &&
        !Array.isArray(values[key]) &&
        isEmptyCustom(values[key])
      ) {
        delete values[key];
      } else if (
        Array.isArray(values[key]) &&
        values[key].every((value: any) => value === null)
      ) {
        delete values[key];
      }
    }
  }
  return values;
};
export function isEmptyCustom(obj: any) {
  // because Object.keys(new Date()).length === 0;
  // we have to do some additional check
  if (!obj) {
    return true;
  }
  return Object.keys(obj).length === 0 && obj.constructor === Object;
}

export type ModelFormGroupExtended<T> = {
  [K in keyof T]: T[K] extends Array<infer U>
    ?
        | FormArray<FormControl<U>>
        | FormControl<T[K]>
        | FormArray<ModelFormGroupExtendedNested<U>>
    : T[K] extends object
    ? ModelFormGroupExtendedNested<T[K]>
    : FormControl<T[K]>;
};

type ModelFormGroupExtendedNested<T> = T extends object
  ? FormGroup<ModelFormGroupExtended<T>>
  : FormControl<T>;

const fb = new UntypedFormBuilder();

export const editorConfig = {
  dialogsInBody: true,
  placeholder: '',
  tabsize: 2,
  height: '175px',
  toolbar: [
    ['misc', ['codeview', 'style', 'undo', 'redo']],
    ['style', ['bold', 'italic', 'underline']],
    ['para', ['ul', 'ol', 'paragraph']],
    ['insert', ['table', 'link', 'hr']],
  ],
};
